var ZH_CN = ['秒', '分钟', '小时', '天', '周', '个月', '年'];
export default function (diff, idx) {
    if (idx === 0)
        return ['刚刚', '片刻后'];
    var unit = ZH_CN[~~(idx / 2)];
    return [diff + " " + unit + "\u524D", diff + " " + unit + "\u540E"];
}
//# sourceMappingURL=zh_CN.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/timeago.js/esm/lang/zh_CN.js
// module id = 5222
// module chunks = 0